import PropTypes from 'prop-types'
import React from 'react'
import cx from 'classnames'

import { toCssClass } from 'helpers'
import { BUILDING_TITLES } from 'helpers/i18n.jsx'

import styles from './ConstructBuilding.scss'

const ConstructBuilding = ({ isActive, type }) => {
    return (
        <div className={cx(styles.base, isActive && styles.base__active)}>
            <p className={styles.caption}>{BUILDING_TITLES[type]}</p>
            <div className={styles.thumbnail}>
                <div className={cx(styles.image, styles[`image__${toCssClass(type)}`])} />
                <span className={styles.shadow} />
            </div>
        </div>
    )
}
ConstructBuilding.propTypes = {
    type: PropTypes.string.isRequired,
    isActive: PropTypes.bool.isRequired,
}

export default ConstructBuilding



// WEBPACK FOOTER //
// ./containers/Construct/components/ConstructBuilding/ConstructBuilding.jsx